// extracted by mini-css-extract-plugin
export var active = "ToggleButton-module--active--cf813";
export var alwaysSmall = "ToggleButton-module--alwaysSmall--23dd3";
export var button = "ToggleButton-module--button--d73e9";
export var left = "ToggleButton-module--left--4ad33";
export var right = "ToggleButton-module--right--6de7f";
export var toggle = "ToggleButton-module--toggle--2758a";